import React, { useEffect, useState } from 'react';
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import NoDataAvailable from '../NoDataAvailable';
import { Spinner } from 'react-bootstrap';
import ChartTitle from '../../../../../elements/ChartTitle';

const GRAPH_TITLE = 'Defects Logged By Priority And Status';

const DefectsLoggedPerStatus = ({
  data,
  dateFilters,
  loading,
  isJiraIntegrated,
  getPriorityColor,
  handleRefresh,
  isFetching
}) => {
  const [chartData, setChartData] = useState([]);
  const [priorities, setPriorities] = useState([]);

  const processChartData = () => {
    const statusPriorityCount = {};
    const prioritySet = new Set();

    data?.forEach(({ status = 'Unassigned', priority = 'Unknown' }) => {
      prioritySet.add(priority);

      if (!statusPriorityCount[status]) {
        statusPriorityCount[status] = { status };
      }

      statusPriorityCount[status][priority] =
        (statusPriorityCount[status][priority] || 0) + 1;
    });

    setPriorities([...prioritySet]);

    return Object.values(statusPriorityCount);
  };

  useEffect(() => {
    if (data.length > 0) {
      const result = processChartData();
      setChartData(result);
    } else {
      setChartData([]);
      setPriorities([]);
    }
  }, [data]);

  const priorityColors = priorities.reduce((colors, priority) => {
    colors[priority] = getPriorityColor(priority);
    return colors;
  }, {});

  const totalCount = chartData.reduce(
    (total, { status, ...counts }) => total + Object.values(counts).reduce((sum, count) => sum + count, 0),
    0
  );
  
  return (
    <div className="chart-div">
      <ChartTitle
        title={GRAPH_TITLE}
        showWarning={!isJiraIntegrated}
        dateFilters={dateFilters}
        onRefresh={handleRefresh}
        isFetching={isFetching}
        showRefreshButton={!loading && isJiraIntegrated}
      />
      {loading ? (
        <Spinner className="mt-5" />
      ) : chartData.length === 0 ? (
        <NoDataAvailable />
      ) : (
        <>
          <p className="text-muted mb-0">Total Defects Logged: {totalCount}</p>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              width={900}
              height={500}
              barSize={25}
              data={chartData}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="status"
                label={{
                  value: 'Status',
                  position: 'insideBottom',
                  offset: -10,
                }}
                tick={{ fontSize: 12 }}
              />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Legend wrapperStyle={{ padding: 10 }} />
              {priorities.map((priority) => (
                <Bar
                  key={priority}
                  dataKey={priority}
                  stackId="a"
                  fill={priorityColors[priority]}
                  name={priority}
                />
              ))}
            </BarChart>
          </ResponsiveContainer>
        </>
      )}
    </div>
  );
};

export default DefectsLoggedPerStatus;
